export default "__VITE_ASSET__C6jDrCF5__"